
export default function TabContents({children}) {
  return (
    <tabcontent-component>
        {children}
    </tabcontent-component>
  )
}
